import styled from "styled-components";

export const IntDropdownArea = ({children, maxHeight = '10rem', width = ''}) => {
  return <Container maxHeight={maxHeight} width={width}>
    {children}
  </Container>
}

const Container = styled.div`
  padding: 1rem 0;
  box-shadow: var(--int-box-shadow-color) 0 0 10px 0;
  border-radius: .4rem;
  overflow-y: auto;
  width: ${props => `${props.width}`};
  height: max-content;
  max-height: ${props => `${props.maxHeight}`};
  background-color: var(--int-droparea-bg-color, #fff);
`;